module.exports = "/assets/10e30d10f2fc3955da255991eb932b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VH.png
// module id = 1926
// module chunks = 0